import React from "react";

import InfoTooltip from "./InfoTooltip";
import s from "./ui.module.scss";

interface FormFieldProps {
  label?: React.ReactNode;
  required?: boolean;
  /** Helper text shown below the control (hidden when `error` is set). */
  hint?: React.ReactNode;
  /**
   * An explanation behind an icon next to the label. For the meaning of the
   * FIELD — what it does and what happens if you get it wrong — where `hint`
   * is for short standing guidance that belongs on screen permanently.
   */
  tooltip?: React.ReactNode;
  /** Error message; also implies the control should render its `invalid` state. */
  error?: React.ReactNode;
  htmlFor?: string;
  className?: string;
  children: React.ReactNode;
}

// Label + control + hint/error wrapper for migrated forms.
const FormField = ({ label, required, hint, tooltip, error, htmlFor, className, children }: FormFieldProps) => (
  <div className={[s.formField, className].filter(Boolean).join(" ")}>
    {label && (
      <label className={s.formLabel} htmlFor={htmlFor}>
        {label}
        {required && <span className={s.formReq}> *</span>}
        {tooltip && (
          <InfoTooltip
            text={tooltip}
            label={typeof label === "string" ? `What is ${label}?` : "More information"}
          />
        )}
      </label>
    )}
    {children}
    {error ? (
      <span className={s.formError}>{error}</span>
    ) : hint ? (
      <span className={s.formHint}>{hint}</span>
    ) : null}
  </div>
);

export default FormField;
